import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class LoginRequiredGuard implements CanActivate {

  constructor(private readonly oauthService: OAuthService) { }
  public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const now = new Date();
    const token = this.oauthService.getAccessToken();
    const exp = new Date(this.oauthService.getAccessTokenExpiration());
    const expired = exp < now;

    if (token != null && !expired || !this.oauthService.discoveryDocumentLoaded) {
      return true;
    }
    this.oauthService.initCodeFlow(state.url);
    return false;
  }
}
